"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hamburgerButton = _interopRequireDefault(require("../hamburger-button"));
var _navPanel = require("./hamburger-nav/nav-panel");
var _excluded = ["label", "labelWhenOpen", "labelWhenClosed", "onClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var MenuButton = function MenuButton(_ref) {
  var isHamburgerNavOpen = _ref.isHamburgerNavOpen,
    menuButtonProps = _ref.menuButtonProps,
    setIsHamburgerNavOpen = _ref.setIsHamburgerNavOpen,
    useBuiltInHamburgerNav = _ref.useBuiltInHamburgerNav;
  var label = menuButtonProps.label,
    labelWhenOpen = menuButtonProps.labelWhenOpen,
    labelWhenClosed = menuButtonProps.labelWhenClosed,
    _onClick = menuButtonProps.onClick,
    otherProps = _objectWithoutProperties(menuButtonProps, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-globalNav__menuButton sb-global-gutters--margin"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "absoluteCenter-y"
  }, /*#__PURE__*/_react["default"].createElement(_hamburgerButton["default"], _extends({
    "aria-controls": _navPanel.PRIMARY_HAMBURGER_PANEL_ID,
    className: "color-textBlackSoft",
    closeButtonAriaLabel: labelWhenOpen,
    hamburgerOpen: isHamburgerNavOpen,
    menuButtonAriaLabel: label || labelWhenClosed,
    onClick: function onClick(e) {
      if (useBuiltInHamburgerNav) {
        setIsHamburgerNavOpen(!isHamburgerNavOpen);
      }
      _onClick && _onClick(e);
    }
  }, otherProps))));
};
MenuButton.propTypes = process.env.NODE_ENV !== "production" ? {
  isHamburgerNavOpen: _propTypes["default"].bool,
  menuButtonProps: _propTypes["default"].object,
  setIsHamburgerNavOpen: _propTypes["default"].func,
  useBuiltInHamburgerNav: _propTypes["default"].bool
} : {};
var _default = exports["default"] = MenuButton;